document.addEventListener("DOMContentLoaded", function () {

  const btn = document.querySelector(".wd-category-btn");
  const menu = document.querySelector(".wd-category-dropdown");

  if (btn && menu) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      menu.classList.toggle("active");
    });
  }

});

document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.querySelector(".wd-mobile-toggle");
  const menu = document.querySelector(".wd-navbar");

  console.log("Button:", openBtn);
  console.log("Menu:", menu);

  if (openBtn && menu) {
    openBtn.addEventListener("click", function () {
      console.log("Hamburger clicked");
      menu.classList.toggle("active");
    });
  }
});